// extracted by mini-css-extract-plugin
export default {"zoomContainer":"ZoomableImage_zoomContainer__1C5df","zoomImage":"ZoomableImage_zoomImage__0YjCF","controls":"ZoomableImage_controls__PVtz5"};